<template>
  <!-- 遮罩层 也是整个组件的容器-->
  <div class="pop-container" v-if="isShow">
    <div class="message-container">
      <!-- 两个icon放在一个容器中，但是只显示一个 -->
      <div class="icon-container">
        <div class="icon-container-success" v-if="type === 'success'">
          <i class="el-icon-check"></i>
        </div>
        <div class="icon-container-error" v-if="type === 'error'">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <span class="message-text">{{ text }}</span>
    </div>
  </div>
</template>


<script>
export default {
  name: 'message',
  props: {
    type: {               // type控制是成功还是失败
      type: String,
      default: 'success',
    },
    text: {              // 弹窗的文字信息
      type: String,
      default: '',
    },
    isShow: {             // 整个遮罩和弹窗是否显示
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss">
.pop-container {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  bottom: 0;
  // backdrop-filter: blur(2px);
  background-color: rgba(102, 101, 101, 0.342);
}
.message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 204px;
  padding: 0 30px;
  height: 100px;
  background: #003554;
  box-shadow: 0px 0px 30px rgba(36, 36, 36, 0.342);
  border-radius: 12px;
}
.icon-container {
  position: relative;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  &-error {
    background-color: #fe1b1b;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    .icon-close {
      position: absolute;
      right: 5px;
      bottom: 5px;
      font-weight: 900;
      font-size: 30px;
      color: #fff;
    }
  }
  &-success {
    background-color: #4ad991;
    height: 40px;
    width: 40px;
    border-radius: 50%;
    .el-icon-check {
      position: absolute;
      color:white;
      right: 4px;
      bottom: 5px;
      font-size: 30px;
      font-weight: 900;
    }
  }
}
.message-text {
  margin-left: 12px;
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  color:#fff;
}
</style>


// WEBPACK FOOTER //
// src/components/alter/message.vue